import React, { useState } from 'react';
import { ingredients } from '../mock';
import { Plus, RotateCcw, Sparkles } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const BuildBowl = () => {
  const [bowl, setBowl] = useState([]);

  const addToBowl = (ing) => {
    if (bowl.length >= 6) {
      toast({ title: 'Bowl is full!', description: 'That\u2019s a serious crunch stack. Reset to build a new one.' });
      return;
    }
    setBowl([...bowl, { ...ing, uid: Date.now() + Math.random() }]);
    if (bowl.length + 1 === 6) {
      toast({ title: '🍽️ Perfect Crunch!', description: 'You built the ultimate TruCrunch bowl. Now play the game!' });
    }
  };

  const reset = () => setBowl([]);

  return (
    <section id="build" className="px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Build your bowl</div>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">
            Can you build<br />a better snack?
          </h2>
          <p className="font-brico text-lg mt-4 opacity-70">Tap ingredients into the bowl to create your perfect crunch!</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mt-10 items-center">
          {/* Ingredient tray */}
          <div className="grid grid-cols-3 gap-4">
            {ingredients.map((ing) => (
              <button
                key={ing.id}
                onClick={() => addToBowl(ing)}
                className="group bg-white rounded-3xl crunch-shadow-sm p-3 hover:-translate-y-1 transition-transform text-left"
              >
                <div className="aspect-square overflow-hidden rounded-2xl">
                  <img src={ing.image} alt={ing.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform" />
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="font-display text-sm uppercase">{ing.name}</span>
                  <span className="w-7 h-7 rounded-full bg-[#1a1a1a] text-[#FFF4E6] flex items-center justify-center">
                    <Plus size={14} />
                  </span>
                </div>
              </button>
            ))}
          </div>

          {/* Bowl */}
          <div className="relative">
            <div className="aspect-square rounded-full bg-gradient-to-br from-[#FFD84D] to-[#F4A261] crunch-shadow relative overflow-hidden flex items-center justify-center">
              <div className="absolute inset-8 rounded-full bg-[#FFF4E6] flex items-center justify-center">
                {bowl.length === 0 ? (
                  <div className="text-center px-6">
                    <Sparkles className="mx-auto text-[#E63946]" size={32} />
                    <p className="font-display text-2xl mt-3 uppercase">Tap ingredients →</p>
                    <p className="font-brico text-sm opacity-70 mt-2">Add 6 to unlock the perfect crunch!</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-3 gap-2 p-6">
                    {bowl.map((b) => (
                      <div key={b.uid} className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden crunch-shadow-sm pop-in">
                        <img src={b.image} alt={b.name} className="w-full h-full object-cover" />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="mt-6 flex items-center justify-between">
              <span className="font-brico font-bold">{bowl.length}/6 added</span>
              <button onClick={reset} className="btn-chunky outline"><RotateCcw size={16} /> Reset</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildBowl;
